<sd-scan-3d-panel
  [globalStyle]="globalStyle()"
  [elevationPicking]="elevationPicking()"
  (elevationPickingChange)="onElevationPickingChange($event)"
></sd-scan-3d-panel>
